var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M52.2891 54C53.3936 54 54.2891 53.1046 54.2891 52C54.2891 50.8954 53.3936 50 52.2891 50C51.1845 50 50.2891 50.8954 50.2891 52C50.2891 53.1046 51.1845 54 52.2891 54Z",
    fill: "#F49E00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.28906 4C3.39363 4 4.28906 3.10457 4.28906 2C4.28906 0.895431 3.39363 0 2.28906 0C1.18449 0 0.289062 0.895431 0.289062 2C0.289062 3.10457 1.18449 4 2.28906 4Z",
    fill: "#F49E00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContainer);
export default __webpack_public_path__ + "static/media/icon-container.aa0105826b2c684a8a760f79fcbc0c65.svg";
export { ForwardRef as ReactComponent };